import {
  enumeratedLiterals,
  type EnumeratedLiteralType,
  type EnumeratedLiteralModel,
} from "./enumeratedLiterals";

export const Currencies = enumeratedLiterals(
  [
    "AED",
    "AFN",
    "ALL",
    "AMD",
    "ANG",
    "AOA",
    "ARS",
    "AUD",
    "AWG",
    "AZN",
    "BAM",
    "BBD",
    "BDT",
    "BGN",
    "BHD",
    "BIF",
    "BMD",
    "BND",
    "BOB",
    "BRL",
    "BSD",
    "BTN",
    "BWP",
    "BYN",
    "BZD",
    "CAD",
    "CDF",
    "CHF",
    "CLF",
    "CLP",
    "CNH",
    "CNY",
    "COP",
    "CRC",
    "CUC",
    "CUP",
    "CVE",
    "CZK",
    "DJF",
    "DKK",
    "DOP",
    "DZD",
    "EGP",
    "ERN",
    "ETB",
    "EUR",
    "FJD",
    "FKP",
    "GBP",
    "GEL",
    "GGP",
    "GHS",
    "GIP",
    "GMD",
    "GNF",
    "GTQ",
    "GYD",
    "HKD",
    "HNL",
    "HRK",
    "HTG",
    "HUF",
    "IDR",
    "ILS",
    "IMP",
    "INR",
    "IQD",
    "IRR",
    "ISK",
    "JEP",
    "JMD",
    "JOD",
    "JPY",
    "KES",
    "KGS",
    "KHR",
    "KMF",
    "KPW",
    "KRW",
    "KWD",
    "KYD",
    "KZT",
    "LAK",
    "LBP",
    "LKR",
    "LRD",
    "LSL",
    "LYD",
    "MAD",
    "MDL",
    "MGA",
    "MKD",
    "MMK",
    "MNT",
    "MOP",
    "MRU",
    "MUR",
    "MVR",
    "MWK",
    "MXN",
    "MYR",
    "MZN",
    "NAD",
    "NGN",
    "NIO",
    "NOK",
    "NPR",
    "NZD",
    "OMR",
    "PAB",
    "PEN",
    "PGK",
    "PHP",
    "PKR",
    "PLN",
    "PYG",
    "QAR",
    "RON",
    "RSD",
    "RUB",
    "RWF",
    "SAR",
    "SBD",
    "SCR",
    "SDG",
    "SEK",
    "SGD",
    "SHP",
    "SLL",
    "SOS",
    "SRD",
    "SSP",
    "STD",
    "STN",
    "SVC",
    "SYP",
    "SZL",
    "THB",
    "TJS",
    "TMT",
    "TND",
    "TOP",
    "TRY",
    "TTD",
    "TWD",
    "TZS",
    "UAH",
    "UGX",
    "USD",
    "UYU",
    "UZS",
    "VEF",
    "VES",
    "VND",
    "VUV",
    "WST",
    "XAF",
    "XCD",
    "XDR",
    "XOF",
    "XPF",
    "YER",
    "ZAR",
    "ZMW",
    "ZWL",
  ] as const,
  {
    getLabels: (a) =>
      ({
        [a.AED]: "United Arab Emirates Dirham",
        [a.AFN]: "Afghan Afghani",
        [a.ALL]: "Albanian Lek",
        [a.AMD]: "Armenian Dram",
        [a.ANG]: "Netherlands Antillean Guilder",
        [a.AOA]: "Angolan Kwanza",
        [a.ARS]: "Argentine Peso",
        [a.AUD]: "Australian Dollar",
        [a.AWG]: "Aruban Florin",
        [a.AZN]: "Azerbaijani Manat",
        [a.BAM]: "Bosnia-Herzegovina Convertible Mark",
        [a.BBD]: "Barbadian Dollar",
        [a.BDT]: "Bangladeshi Taka",
        [a.BGN]: "Bulgarian Lev",
        [a.BHD]: "Bahraini Dinar",
        [a.BIF]: "Burundian Franc",
        [a.BMD]: "Bermudan Dollar",
        [a.BND]: "Brunei Dollar",
        [a.BOB]: "Bolivian Boliviano",
        [a.BRL]: "Brazilian Real",
        [a.BSD]: "Bahamian Dollar",
        [a.BTN]: "Bhutanese Ngultrum",
        [a.BWP]: "Botswanan Pula",
        [a.BYN]: "Belarusian Ruble",
        [a.BZD]: "Belize Dollar",
        [a.CAD]: "Canadian Dollar",
        [a.CDF]: "Congolese Franc",
        [a.CHF]: "Swiss Franc",
        [a.CLF]: "Chilean Unit of Account (UF)",
        [a.CLP]: "Chilean Peso",
        [a.CNH]: "Chinese Yuan (Offshore)",
        [a.CNY]: "Chinese Yuan",
        [a.COP]: "Colombian Peso",
        [a.CRC]: "Costa Rican Colón",
        [a.CUC]: "Cuban Convertible Peso",
        [a.CUP]: "Cuban Peso",
        [a.CVE]: "Cape Verdean Escudo",
        [a.CZK]: "Czech Republic Koruna",
        [a.DJF]: "Djiboutian Franc",
        [a.DKK]: "Danish Krone",
        [a.DOP]: "Dominican Peso",
        [a.DZD]: "Algerian Dinar",
        [a.EGP]: "Egyptian Pound",
        [a.ERN]: "Eritrean Nakfa",
        [a.ETB]: "Ethiopian Birr",
        [a.EUR]: "Euro",
        [a.FJD]: "Fijian Dollar",
        [a.FKP]: "Falkland Islands Pound",
        [a.GBP]: "British Pound Sterling",
        [a.GEL]: "Georgian Lari",
        [a.GGP]: "Guernsey Pound",
        [a.GHS]: "Ghanaian Cedi",
        [a.GIP]: "Gibraltar Pound",
        [a.GMD]: "Gambian Dalasi",
        [a.GNF]: "Guinean Franc",
        [a.GTQ]: "Guatemalan Quetzal",
        [a.GYD]: "Guyanaese Dollar",
        [a.HKD]: "Hong Kong Dollar",
        [a.HNL]: "Honduran Lempira",
        [a.HRK]: "Croatian Kuna",
        [a.HTG]: "Haitian Gourde",
        [a.HUF]: "Hungarian Forint",
        [a.IDR]: "Indonesian Rupiah",
        [a.ILS]: "Israeli New Sheqel",
        [a.IMP]: "Manx pound",
        [a.INR]: "Indian Rupee",
        [a.IQD]: "Iraqi Dinar",
        [a.IRR]: "Iranian Rial",
        [a.ISK]: "Icelandic Króna",
        [a.JEP]: "Jersey Pound",
        [a.JMD]: "Jamaican Dollar",
        [a.JOD]: "Jordanian Dinar",
        [a.JPY]: "Japanese Yen",
        [a.KES]: "Kenyan Shilling",
        [a.KGS]: "Kyrgystani Som",
        [a.KHR]: "Cambodian Riel",
        [a.KMF]: "Comorian Franc",
        [a.KPW]: "North Korean Won",
        [a.KRW]: "South Korean Won",
        [a.KWD]: "Kuwaiti Dinar",
        [a.KYD]: "Cayman Islands Dollar",
        [a.KZT]: "Kazakhstani Tenge",
        [a.LAK]: "Laotian Kip",
        [a.LBP]: "Lebanese Pound",
        [a.LKR]: "Sri Lankan Rupee",
        [a.LRD]: "Liberian Dollar",
        [a.LSL]: "Lesotho Loti",
        [a.LYD]: "Libyan Dinar",
        [a.MAD]: "Moroccan Dirham",
        [a.MDL]: "Moldovan Leu",
        [a.MGA]: "Malagasy Ariary",
        [a.MKD]: "Macedonian Denar",
        [a.MMK]: "Myanma Kyat",
        [a.MNT]: "Mongolian Tugrik",
        [a.MOP]: "Macanese Pataca",
        [a.MRU]: "Mauritanian Ouguiya",
        [a.MUR]: "Mauritian Rupee",
        [a.MVR]: "Maldivian Rufiyaa",
        [a.MWK]: "Malawian Kwacha",
        [a.MXN]: "Mexican Peso",
        [a.MYR]: "Malaysian Ringgit",
        [a.MZN]: "Mozambican Metical",
        [a.NAD]: "Namibian Dollar",
        [a.NGN]: "Nigerian Naira",
        [a.NIO]: "Nicaraguan Córdoba",
        [a.NOK]: "Norwegian Krone",
        [a.NPR]: "Nepalese Rupee",
        [a.NZD]: "New Zealand Dollar",
        [a.OMR]: "Omani Rial",
        [a.PAB]: "Panamanian Balboa",
        [a.PEN]: "Peruvian Nuevo Sol",
        [a.PGK]: "Papua New Guinean Kina",
        [a.PHP]: "Philippine Peso",
        [a.PKR]: "Pakistani Rupee",
        [a.PLN]: "Polish Zloty",
        [a.PYG]: "Paraguayan Guarani",
        [a.QAR]: "Qatari Rial",
        [a.RON]: "Romanian Leu",
        [a.RSD]: "Serbian Dinar",
        [a.RUB]: "Russian Ruble",
        [a.RWF]: "Rwandan Franc",
        [a.SAR]: "Saudi Riyal",
        [a.SBD]: "Solomon Islands Dollar",
        [a.SCR]: "Seychellois Rupee",
        [a.SDG]: "Sudanese Pound",
        [a.SEK]: "Swedish Krona",
        [a.SGD]: "Singapore Dollar",
        [a.SHP]: "Saint Helena Pound",
        [a.SLL]: "Sierra Leonean Leone",
        [a.SOS]: "Somali Shilling",
        [a.SRD]: "Surinamese Dollar",
        [a.SSP]: "South Sudanese Pound",
        [a.STD]: "São Tomé and Príncipe Dobra (pre-2018)",
        [a.STN]: "São Tomé and Príncipe Dobra",
        [a.SVC]: "Salvadoran Colón",
        [a.SYP]: "Syrian Pound",
        [a.SZL]: "Swazi Lilangeni",
        [a.THB]: "Thai Baht",
        [a.TJS]: "Tajikistani Somoni",
        [a.TMT]: "Turkmenistani Manat",
        [a.TND]: "Tunisian Dinar",
        [a.TOP]: "Tongan Pa'anga",
        [a.TRY]: "Turkish Lira",
        [a.TTD]: "Trinidad and Tobago Dollar",
        [a.TWD]: "New Taiwan Dollar",
        [a.TZS]: "Tanzanian Shilling",
        [a.UAH]: "Ukrainian Hryvnia",
        [a.UGX]: "Ugandan Shilling",
        [a.USD]: "United States Dollar",
        [a.UYU]: "Uruguayan Peso",
        [a.UZS]: "Uzbekistan Som",
        [a.VEF]: "Venezuelan Bolívar Fuerte (Old)",
        [a.VES]: "Venezuelan Bolívar Soberano",
        [a.VND]: "Vietnamese Dong",
        [a.VUV]: "Vanuatu Vatu",
        [a.WST]: "Samoan Tala",
        [a.XAF]: "CFA Franc BEAC",
        [a.XCD]: "East Caribbean Dollar",
        [a.XDR]: "Special Drawing Rights",
        [a.XOF]: "CFA Franc BCEAO",
        [a.XPF]: "CFP Franc",
        [a.YER]: "Yemeni Rial",
        [a.ZAR]: "South African Rand",
        [a.ZMW]: "Zambian Kwacha",
        [a.ZWL]: "Zimbabwean Dollar",
      } as const),
    getAttributes: (a) =>
      ({
        [a.AED]: { pluralLabel: "United Arab Emirates Dirhams", symbol: "د.إ" },
        [a.AFN]: { pluralLabel: "Afghan Afghanis", symbol: "؋" },
        [a.ALL]: { pluralLabel: "Albanian Leks", symbol: "L" },
        [a.AMD]: { pluralLabel: "Armenian Drams", symbol: "֏" },
        [a.ANG]: { pluralLabel: "Netherlands Antillean Guilders", symbol: "ƒ" },
        [a.AOA]: { pluralLabel: "Angolan Kwanzas", symbol: "Kz" },
        [a.ARS]: { pluralLabel: "Argentine Pesos", symbol: "$" },
        [a.AUD]: { pluralLabel: "Australian Dollars", symbol: "$" },
        [a.AWG]: { pluralLabel: "Aruban Florins", symbol: "ƒ" },
        [a.AZN]: { pluralLabel: "Azerbaijani Manats", symbol: "₼" },
        [a.BAM]: {
          pluralLabel: "Bosnia-Herzegovina Convertible Marks",
          symbol: "KM",
        },
        [a.BBD]: { pluralLabel: "Barbadian Dollars", symbol: "$" },
        [a.BDT]: { pluralLabel: "Bangladeshi Takas", symbol: "৳" },
        [a.BGN]: { pluralLabel: "Bulgarian Levs", symbol: "лв" },
        [a.BHD]: { pluralLabel: "Bahraini Dinars", symbol: ".د.ب" },
        [a.BIF]: { pluralLabel: "Burundian Francs", symbol: "FBu" },
        [a.BMD]: { pluralLabel: "Bermudan Dollars", symbol: "$" },
        [a.BND]: { pluralLabel: "Brunei Dollars", symbol: "$" },
        [a.BOB]: { pluralLabel: "Bolivian Bolivianos", symbol: "$b" },
        [a.BRL]: { pluralLabel: "Brazilian Reals", symbol: "R$" },
        [a.BSD]: { pluralLabel: "Bahamian Dollars", symbol: "$" },
        [a.BTN]: { pluralLabel: "Bhutanese Ngultrums", symbol: "Nu." },
        [a.BWP]: { pluralLabel: "Botswanan Pulas", symbol: "P" },
        [a.BYN]: { pluralLabel: "Belarusian Rubles", symbol: "Br" },
        [a.BZD]: { pluralLabel: "Belize Dollars", symbol: "BZ$" },
        [a.CAD]: { pluralLabel: "Canadian Dollars", symbol: "$" },
        [a.CDF]: { pluralLabel: "Congolese Francs", symbol: "FC" },
        [a.CHF]: { pluralLabel: "Swiss Francs", symbol: "CHF" },
        [a.CLF]: {
          pluralLabel: "Chilean Unit of Account (UF)s",
          symbol: "CLF",
        },
        [a.CLP]: { pluralLabel: "Chilean Pesos", symbol: "$" },
        [a.CNH]: { pluralLabel: "Chinese Yuan (Offshore)s", symbol: "¥" },
        [a.CNY]: { pluralLabel: "Chinese Yuans", symbol: "¥" },
        [a.COP]: { pluralLabel: "Colombian Pesos", symbol: "$" },
        [a.CRC]: { pluralLabel: "Costa Rican Colóns", symbol: "₡" },
        [a.CUC]: { pluralLabel: "Cuban Convertible Pesos", symbol: "$" },
        [a.CUP]: { pluralLabel: "Cuban Pesos", symbol: "₱" },
        [a.CVE]: { pluralLabel: "Cape Verdean Escudos", symbol: "$" },
        [a.CZK]: { pluralLabel: "Czech Republic Korunas", symbol: "Kč" },
        [a.DJF]: { pluralLabel: "Djiboutian Francs", symbol: "Fdj" },
        [a.DKK]: { pluralLabel: "Danish Krones", symbol: "kr" },
        [a.DOP]: { pluralLabel: "Dominican Pesos", symbol: "RD$" },
        [a.DZD]: { pluralLabel: "Algerian Dinars", symbol: "دج" },
        [a.EGP]: { pluralLabel: "Egyptian Pounds", symbol: "£" },
        [a.ERN]: { pluralLabel: "Eritrean Nakfas", symbol: "Nfk" },
        [a.ETB]: { pluralLabel: "Ethiopian Birrs", symbol: "Br" },
        [a.EUR]: { pluralLabel: "Euros", symbol: "€" },
        [a.FJD]: { pluralLabel: "Fijian Dollars", symbol: "$" },
        [a.FKP]: { pluralLabel: "Falkland Islands Pounds", symbol: "£" },
        [a.GBP]: { pluralLabel: "British Pound Sterlings", symbol: "£" },
        [a.GEL]: { pluralLabel: "Georgian Laris", symbol: "₾" },
        [a.GGP]: { pluralLabel: "Guernsey Pounds", symbol: "£" },
        [a.GHS]: { pluralLabel: "Ghanaian Cedis", symbol: "GH₵" },
        [a.GIP]: { pluralLabel: "Gibraltar Pounds", symbol: "£" },
        [a.GMD]: { pluralLabel: "Gambian Dalasis", symbol: "D" },
        [a.GNF]: { pluralLabel: "Guinean Francs", symbol: "FG" },
        [a.GTQ]: { pluralLabel: "Guatemalan Quetzals", symbol: "Q" },
        [a.GYD]: { pluralLabel: "Guyanaese Dollars", symbol: "$" },
        [a.HKD]: { pluralLabel: "Hong Kong Dollars", symbol: "$" },
        [a.HNL]: { pluralLabel: "Honduran Lempiras", symbol: "L" },
        [a.HRK]: { pluralLabel: "Croatian Kunas", symbol: "kn" },
        [a.HTG]: { pluralLabel: "Haitian Gourdes", symbol: "G" },
        [a.HUF]: { pluralLabel: "Hungarian Forints", symbol: "Ft" },
        [a.IDR]: { pluralLabel: "Indonesian Rupiahs", symbol: "Rp" },
        [a.ILS]: { pluralLabel: "Israeli New Sheqels", symbol: "₪" },
        [a.IMP]: { pluralLabel: "Manx pounds", symbol: "£" },
        [a.INR]: { pluralLabel: "Indian Rupees", symbol: "₹" },
        [a.IQD]: { pluralLabel: "Iraqi Dinars", symbol: "ع.د" },
        [a.IRR]: { pluralLabel: "Iranian Rials", symbol: "﷼" },
        [a.ISK]: { pluralLabel: "Icelandic Krónas", symbol: "kr" },
        [a.JEP]: { pluralLabel: "Jersey Pounds", symbol: "£" },
        [a.JMD]: { pluralLabel: "Jamaican Dollars", symbol: "J$" },
        [a.JOD]: { pluralLabel: "Jordanian Dinars", symbol: "JD" },
        [a.JPY]: { pluralLabel: "Japanese Yens", symbol: "¥" },
        [a.KES]: { pluralLabel: "Kenyan Shillings", symbol: "KSh" },
        [a.KGS]: { pluralLabel: "Kyrgystani Soms", symbol: "лв" },
        [a.KHR]: { pluralLabel: "Cambodian Riels", symbol: "៛" },
        [a.KMF]: { pluralLabel: "Comorian Francs", symbol: "CF" },
        [a.KPW]: { pluralLabel: "North Korean Wons", symbol: "₩" },
        [a.KRW]: { pluralLabel: "South Korean Wons", symbol: "₩" },
        [a.KWD]: { pluralLabel: "Kuwaiti Dinars", symbol: "KD" },
        [a.KYD]: { pluralLabel: "Cayman Islands Dollars", symbol: "$" },
        [a.KZT]: { pluralLabel: "Kazakhstani Tenges", symbol: "₸" },
        [a.LAK]: { pluralLabel: "Laotian Kips", symbol: "₭" },
        [a.LBP]: { pluralLabel: "Lebanese Pounds", symbol: "£" },
        [a.LKR]: { pluralLabel: "Sri Lankan Rupees", symbol: "₨" },
        [a.LRD]: { pluralLabel: "Liberian Dollars", symbol: "$" },
        [a.LSL]: { pluralLabel: "Lesotho Lotis", symbol: "M" },
        [a.LYD]: { pluralLabel: "Libyan Dinars", symbol: "LD" },
        [a.MAD]: { pluralLabel: "Moroccan Dirhams", symbol: "MAD" },
        [a.MDL]: { pluralLabel: "Moldovan Leus", symbol: "lei" },
        [a.MGA]: { pluralLabel: "Malagasy Ariarys", symbol: "Ar" },
        [a.MKD]: { pluralLabel: "Macedonian Denars", symbol: "ден" },
        [a.MMK]: { pluralLabel: "Myanma Kyats", symbol: "K" },
        [a.MNT]: { pluralLabel: "Mongolian Tugriks", symbol: "₮" },
        [a.MOP]: { pluralLabel: "Macanese Patacas", symbol: "MOP$" },
        [a.MRU]: { pluralLabel: "Mauritanian Ouguiyas", symbol: "UM" },
        [a.MUR]: { pluralLabel: "Mauritian Rupees", symbol: "₨" },
        [a.MVR]: { pluralLabel: "Maldivian Rufiyaas", symbol: "Rf" },
        [a.MWK]: { pluralLabel: "Malawian Kwachas", symbol: "MK" },
        [a.MXN]: { pluralLabel: "Mexican Pesos", symbol: "$" },
        [a.MYR]: { pluralLabel: "Malaysian Ringgits", symbol: "RM" },
        [a.MZN]: { pluralLabel: "Mozambican Meticals", symbol: "MT" },
        [a.NAD]: { pluralLabel: "Namibian Dollars", symbol: "$" },
        [a.NGN]: { pluralLabel: "Nigerian Nairas", symbol: "₦" },
        [a.NIO]: { pluralLabel: "Nicaraguan Córdobas", symbol: "C$" },
        [a.NOK]: { pluralLabel: "Norwegian Krones", symbol: "kr" },
        [a.NPR]: { pluralLabel: "Nepalese Rupees", symbol: "₨" },
        [a.NZD]: { pluralLabel: "New Zealand Dollars", symbol: "$" },
        [a.OMR]: { pluralLabel: "Omani Rials", symbol: "﷼" },
        [a.PAB]: { pluralLabel: "Panamanian Balboas", symbol: "B/." },
        [a.PEN]: { pluralLabel: "Peruvian Nuevo Sols", symbol: "S/." },
        [a.PGK]: { pluralLabel: "Papua New Guinean Kinas", symbol: "K" },
        [a.PHP]: { pluralLabel: "Philippine Pesos", symbol: "₱" },
        [a.PKR]: { pluralLabel: "Pakistani Rupees", symbol: "₨" },
        [a.PLN]: { pluralLabel: "Polish Zlotys", symbol: "zł" },
        [a.PYG]: { pluralLabel: "Paraguayan Guaranis", symbol: "Gs" },
        [a.QAR]: { pluralLabel: "Qatari Rials", symbol: "﷼" },
        [a.RON]: { pluralLabel: "Romanian Leus", symbol: "lei" },
        [a.RSD]: { pluralLabel: "Serbian Dinars", symbol: "Дин." },
        [a.RUB]: { pluralLabel: "Russian Rubles", symbol: "₽" },
        [a.RWF]: { pluralLabel: "Rwandan Francs", symbol: "R₣" },
        [a.SAR]: { pluralLabel: "Saudi Riyals", symbol: "﷼" },
        [a.SBD]: { pluralLabel: "Solomon Islands Dollars", symbol: "$" },
        [a.SCR]: { pluralLabel: "Seychellois Rupees", symbol: "₨" },
        [a.SDG]: { pluralLabel: "Sudanese Pounds", symbol: "ج.س." },
        [a.SEK]: { pluralLabel: "Swedish Kronas", symbol: "kr" },
        [a.SGD]: { pluralLabel: "Singapore Dollars", symbol: "S$" },
        [a.SHP]: { pluralLabel: "Saint Helena Pounds", symbol: "£" },
        [a.SLL]: { pluralLabel: "Sierra Leonean Leones", symbol: "Le" },
        [a.SOS]: { pluralLabel: "Somali Shillings", symbol: "S" },
        [a.SRD]: { pluralLabel: "Surinamese Dollars", symbol: "$" },
        [a.SSP]: { pluralLabel: "South Sudanese Pounds", symbol: "£" },
        [a.STD]: {
          pluralLabel: "São Tomé and Príncipe Dobra (pre-2018)s",
          symbol: "Db",
        },
        [a.STN]: { pluralLabel: "São Tomé and Príncipe Dobras", symbol: "Db" },
        [a.SVC]: { pluralLabel: "Salvadoran Colóns", symbol: "$" },
        [a.SYP]: { pluralLabel: "Syrian Pounds", symbol: "£" },
        [a.SZL]: { pluralLabel: "Swazi Lilangenis", symbol: "E" },
        [a.THB]: { pluralLabel: "Thai Bahts", symbol: "฿" },
        [a.TJS]: { pluralLabel: "Tajikistani Somonis", symbol: "SM" },
        [a.TMT]: { pluralLabel: "Turkmenistani Manats", symbol: "T" },
        [a.TND]: { pluralLabel: "Tunisian Dinars", symbol: "د.ت" },
        [a.TOP]: { pluralLabel: "Tongan Pa'angas", symbol: "T$" },
        [a.TRY]: { pluralLabel: "Turkish Liras", symbol: "₺" },
        [a.TTD]: { pluralLabel: "Trinidad and Tobago Dollars", symbol: "TT$" },
        [a.TWD]: { pluralLabel: "New Taiwan Dollars", symbol: "NT$" },
        [a.TZS]: { pluralLabel: "Tanzanian Shillings", symbol: "TSh" },
        [a.UAH]: { pluralLabel: "Ukrainian Hryvnias", symbol: "₴" },
        [a.UGX]: { pluralLabel: "Ugandan Shillings", symbol: "USh" },
        [a.USD]: { pluralLabel: "United States Dollars", symbol: "$" },
        [a.UYU]: { pluralLabel: "Uruguayan Pesos", symbol: "$U" },
        [a.UZS]: { pluralLabel: "Uzbekistan Soms", symbol: "лв" },
        [a.VEF]: {
          pluralLabel: "Venezuelan Bolívar Fuerte (Old)s",
          symbol: "Bs",
        },
        [a.VES]: {
          pluralLabel: "Venezuelan Bolívar Soberanos",
          symbol: "Bs.S",
        },
        [a.VND]: { pluralLabel: "Vietnamese Dongs", symbol: "₫" },
        [a.VUV]: { pluralLabel: "Vanuatu Vatus", symbol: "VT" },
        [a.WST]: { pluralLabel: "Samoan Talas", symbol: "WS$" },
        [a.XAF]: { pluralLabel: "CFA Franc BEACs", symbol: "FCFA" },
        [a.XCD]: { pluralLabel: "East Caribbean Dollars", symbol: "$" },
        [a.XDR]: {
          pluralLabel: "Special Drawing Rightss",
          symbol: undefined,
        },
        [a.XOF]: { pluralLabel: "CFA Franc BCEAOs", symbol: "CFA" },
        [a.XPF]: { pluralLabel: "CFP Francs", symbol: "₣" },
        [a.YER]: { pluralLabel: "Yemeni Rials", symbol: "﷼" },
        [a.ZAR]: { pluralLabel: "South African Rands", symbol: "R" },
        [a.ZMW]: { pluralLabel: "Zambian Kwachas", symbol: "ZK" },
        [a.ZWL]: { pluralLabel: "Zimbabwean Dollars", symbol: "$" },
      } as const),
  },
);

export type CurrencyCode = EnumeratedLiteralType<typeof Currencies>;
export type Currency = EnumeratedLiteralModel<typeof Currencies>;
